export default {
    computed: {
        auditLookupMap() {
            const gp = this.$store.state.geschaeftspartner
            const crm = this.$store.state.crm
            const korresp = this.$store.state.korrespondenz
            const journal = this.$store.state.journal
            const noten = this.$store.state.noten
            const anmeldung = this.$store.state.anmeldung
            const map = {}
            ;[
                gp.anreden, gp.geschlechter, gp.emailtypen, gp.bonitaeten,
                gp.akademischetitel, gp.interessen, gp.zivilstaende,
                gp.nationalitaeten, gp.sprachen, gp.aufenthaltsbewilligungen,
                gp.anstellungsarten, gp.aktivitaetsstati, gp.kantone,
                gp.partnerrollen, gp.qualifikationtypen, gp.niveau,
                gp.adressverwendungstypen, gp.relationtypen, gp.relationarten,
                gp.relationsstati, gp.firma_partnerrollen, gp.branchen,
                gp.kompetenzstufen, gp.unterrichtssprachen, gp.einreichungstati,
                gp.konkordate, gp.institutionen, gp.ernaehrungen, gp.funktionsbereiche,
                crm.aktivitaettypen, crm.aktivitaetstati, crm.leadquellen,
                crm.leadstages, crm.leadtypen, crm.kontaktrollen,
                korresp.kontaktarten, korresp.kontaktkategorien,
                korresp.verarbeitungsstati, korresp.versandlisten,
                journal.journaleintragtypen, journal.journaleintragstati,
                anmeldung.anmeldetypen, anmeldung.ablehnunggruende,
                anmeldung.anmeldegruende, anmeldung.abmeldegruende,
                anmeldung.anmeldestati, anmeldung.verrechnungen,
                anmeldung.abschluesse,
            ].flat().forEach(item => {
                if (item?.id && item?.bezeichnung) map[item.id] = item.bezeichnung
            })
            // Nationalitaeten: Anzeigefeld ist bezeichnungMitIso, nicht bezeichnung
            gp.nationalitaeten.forEach(item => {
                if (item?.id && item?.bezeichnungMitIso) map[item.id] = item.bezeichnungMitIso
            })
            // Fach (Unterrichtsfächer): Anzeigefeld ist titel, nicht bezeichnung
            noten.faecher.forEach(item => {
                if (item?.id && item?.titel) map[item.id] = item.titel
            })
            return map
        }, 
    },
}